import {useState} from 'react'

import {SelectOption} from '../../../models/utility.model'
import useMasterListService from './useMasterService'

const useTableForMaster = () => {
  const [docType, setDocType] = useState<SelectOption[] | any>([])
  const [nationality, setNationality] = useState<SelectOption[] | any>([])
  const [statusUser, setStatusUser] = useState<SelectOption[] | any>([])
  const [statusAccess, setStatusAccess] = useState<SelectOption[] | any>([])
  const [sex, setSex] = useState<SelectOption[] | any>([])
  const [typeReception, setTypeReception] = useState<SelectOption[] | any>([])
  const [valorations, setValorations] = useState<SelectOption[]>([])
  const [typeData, setTypeData] = useState<SelectOption[]>([])
  const {getMasterMappedData} = useMasterListService()
  const getDocTypeList = async () => {
    try {
      const response = await getMasterMappedData('TipoDocumento')
      const filterData = response.filter(
        (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
      )
      const mappedMaster = filterData.map((master) => ({
        ...master,
        length:
          master.codigo === '04' || master.codigo === '07'
            ? master.campoadicionaltxt5
            : master.campoadicionaltxt1,
      }))
      setDocType(mappedMaster)
    } catch (error) {
      setDocType([])
    }
  }
  const getNationalityList = async () => {
    try {
      const response = await getMasterMappedData('Nacionalidad')
      setNationality(response)
    } catch (error) {
      setNationality([])
    }
  }
  const getSexList = async () => {
    try {
      const response = await getMasterMappedData('Sexo')
      const filterData = response.filter((item) => item.codigo !== '3')
      setSex(filterData)
    } catch (error) {
      setSex([])
    }
  }
  const getStatusUserList = async () => {
    try {
      const response = await getMasterMappedData('EstadoUsuario')
      setStatusUser(response)
    } catch (error) {
      setStatusUser([])
    }
  }
  const getStatusAccessList = async () => {
    try {
      const response = await getMasterMappedData('EstadoAcceso')
      setStatusAccess(response)
    } catch (error) {
      setStatusAccess([])
    }
  }
  const getTypeReceptionList = async () => {
    try {
      const response = await getMasterMappedData('TipoRecepcionador')
      setTypeReception(response)
    } catch (error) {
      setTypeReception([])
    }
  }
  const getValorationList = async (applicationId: string) => {
    try {
      const response = await getMasterMappedData('VALORIZACION', 'id', undefined, {
        campoadicionaltxt1: applicationId,
      })
      setValorations(response)
    } catch (error) {
      setValorations([])
    }
  }

    const getTypeDataList = async () => {
    try {
      const response = await getMasterMappedData('TIPODEFECHA','id')
      setTypeData(response)
    } catch (error) {
      setTypeData([])
    }
  }

  return {
    docType,
    nationality,
    sex,
    statusUser,
    typeReception,
    valorations,
    typeData,
    statusAccess,
    getTypeDataList,
    getDocTypeList,
    getNationalityList,
    getSexList,
    getStatusUserList,
    getTypeReceptionList,
    getValorationList,
    getStatusAccessList,
  }
}

export default useTableForMaster
